/**
 * Domínio de dbpgpp.tb_perfil (IDs canônicos da base).
 */
export enum PerfilEnum {
  ADMINISTRADOR_SISTEMA = 1,
  GESTOR_FEDERAL = 2,
  GESTOR_ESTADUAL = 3,
  GESTOR_MUNICIPAL = 4,
  GESTOR_REGIAO_SAUDE = 5,
  GESTOR_DSEI = 13,
  ADMINISTRADOR_COORDENACAO_NACIONAL = 87,
  /** Representante Gestor (legado: USUARIO_MUNICIPAL). */
  REPRESENTANTE_GESTOR = 99,
  USUARIO_MUNICIPAL = 99,
}

/** HU079 RN006: perfis que editam homologação independentemente da situação. */
export const PERFIS_COORDENACAO_NACIONAL_OU_ADMIN: readonly number[] = [
  PerfilEnum.ADMINISTRADOR_SISTEMA,
  PerfilEnum.GESTOR_FEDERAL,
  PerfilEnum.ADMINISTRADOR_COORDENACAO_NACIONAL,
];

export function isPerfilCoordenacaoNacionalOuAdmin(perfilId: number | null | undefined): boolean {
  return perfilId != null && PERFIS_COORDENACAO_NACIONAL_OU_ADMIN.includes(perfilId);
}
